import React, { useState, useEffect, Component, useRef, forwardRef } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import PracticeGame from "../../components/PracticeGameAssessment";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useSpeech from "../../hooks/useSpeech";
import { debug } from "util";
import { render } from "react-dom";
//import style from './Geo.module.css';
import { Textfit } from 'react-textfit';

import style from '../../components/Geo.module.css';
import { Scale } from 'react-scaling';
//modes
import AsCalculator from "../../components/AsCalculator";
import AsCalculatorFraction from "../../components/AsCalculatorFraction";
import AsCalculatorFractionMixed from "../../components/AsCalculatorFractionMixed";

import axios from "axios";
import useAuth from "../../../auth/hooks/useAuth";

import next from "../../assets/maths_assessments/assets/Next.png";
import back from "../../assets/maths_assessments/assets/Back.png";
import blankbg from "../../assets/maths_assessments/assets/Blank.png";
import marks1 from "../../assets/maths_assessments/assets/marks1.png";

//Holds the current question with elements:
//question: question text
//answers: (correct: bool, value: answer string),
//correct: string of correct answer
var currQuestion;
var image;

//THESE VARIABLES NEED TO BE OUTSIDE THE EXPORT OTHERWISE THEY ARE SET TO DEFAULT EVERY FRAME
var questionNum = 0;
var useranswers = [];
var shuffledAnswers = [];

//Mixes up array
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}


export default function SpringBlock({ ...props }) {
  const [loading, setLoading] = useState(true);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  const { state: authState } = useAuth();
  const [gameOver, setGameOver] = useState(false);

  const [clearCalc, setClear] = useState(false);

  const [questions, setQuestions] = useState([]);

  //this.calculator = React.createRef();


  /*
  const { questions, status } = useTopicQuestions({
    topics: props.topics,
    game_type: props.gameType
  });*/
  const [currentQuestion, setCurrentQuestion] = useState([]);
  const [extraChars, setExtraChars] = useState([]);
  const [refresh, setRefresh] = useState(false)
  const [displayImage, setDisplayImage] = useState(false);

  const[showColouredFeedback, setColouredFeedback] = useState(false);
  const [waitTime, setWaitTime] = useState(2);

  const [status, setStatus] = useState(false);

  //0 = keypad, 
  //1 = multiple choice,
  // 2 = fraction,
  // 3 = int & frac

  //questions section
  var questionsYear2SpringDivision = [];
  questionsYear2SpringDivision.push({ "question" : "Emile is putting 10 gems into jars. He puts 2 gems into each jar. How many jars does he need? ", "answer" : "5", "type": 0, "units" : "jars", "marks" : 1})
questionsYear2SpringDivision.push({ "question" : "Complete the number sentence. ", "answer" : "5", "type": 0, "units" : "", "marks" : 1})
questionsYear2SpringDivision.push({ "question" : "Aimee is putting gems into boxes. She has 12 gems and 2 boxes. How many gems will be in each box? ", "answer" : "6", "type": 0, "units" : "gems", "marks" : 1})
questionsYear2SpringDivision.push({ "question" : "Complete the number sentence. ", "answer" : "6", "type": 0, "units" : "", "marks" : 1})
questionsYear2SpringDivision.push({ "question" : "Emile, Aimee and Scrambler find 6 gems. They share the gems out equally. How many gems do they each get? ", "answer" : "2", "type": 0, "units" : "gems", "marks" : 1})
questionsYear2SpringDivision.push({ "question" : "Complete the number sentence. ", "answer" : "2", "type": 0, "units" : "", "marks" : 1})
questionsYear2SpringDivision.push({ "question" : "Below is a bar model. Using the bar model, complete the number sentence: 20 ÷ 5 = ?", "answer" : "4", "type": 0, "units" : "", "marks" : 1})
questionsYear2SpringDivision.push({ "question" : "Below is another bar model. Using the bar model, complete the number sentence: 50 ÷ 10 = ?", "answer" : "5", "type": 0, "units" : "", "marks" : 1})
questionsYear2SpringDivision.push({ "question" : "Below is a number line. Using the number line, complete the number sentence: 60 ÷ 10 = ?", "answer" : "6", "type": 0, "units" : "", "marks" : 1})
questionsYear2SpringDivision.push({ "question" : "Below is another number line. Using the number line, complete the number sentence: 16 ÷ 2 = ?", "answer" : "8", "type": 0, "units" : "", "marks" : 1})
questionsYear2SpringDivision.push({ "question" : "Emile has a £2 coin. He buys some gems. He is given three 20p coins as change. How much money has Emile spent?  ", "answer" : "1.4", "type": 0, "units" : "£", "marks" : 1})
questionsYear2SpringDivision.push({ "question" : "Is 28 odd or even?", "answer" : "even|odd", "type": 4, "units" : "", "marks" : 1})
questionsYear2SpringDivision.push({ "question" : "Emile has made a number. Is the number odd or even? ", "answer" : "odd|even", "type": 4, "units" : "", "marks" : 1})
questionsYear2SpringDivision.push({ "question" : "Aimee has made a number. Is the number odd or even? ", "answer" : "even|odd", "type": 4, "units" : "", "marks" : 1})


  
  

  var questionsYear2SpringFractions = [];
  questionsYear2SpringFractions.push({ "question" : "What fraction does 1/2 represent? ", "answer" : "A half|A quarter|A third", "type": 1, "units" : "", "marks" : 1})
questionsYear2SpringFractions.push({ "question" : "What fraction does 1/3 represent? ", "answer" : "A third|A quarter|A half", "type": 1, "units" : "", "marks" : 1})
questionsYear2SpringFractions.push({ "question" : "What fraction of the shape is coloured red? ", "answer" : "1/4|1/2|1/3", "type": 1, "units" : "", "marks" : 1})
questionsYear2SpringFractions.push({ "question" : "What fraction of the shape is coloured blue? ", "answer" : "2/3|1/3|1/2", "type": 1, "units" : "", "marks" : 1})
questionsYear2SpringFractions.push({ "question" : "Which shape has a third shaded green? ", "answer" : "C|A|B", "type": 1, "units" : "", "marks" : 1})
questionsYear2SpringFractions.push({ "question" : "Emile has some gems. What fraction of Emile's gems are green? ", "answer" : "1/2|1/3|1/4", "type": 1, "units" : "", "marks" : 1})
questionsYear2SpringFractions.push({ "question" : "What fraction of Emile's gems are red?", "answer" : "1/4|1/3|1/8", "type": 1, "units" : "", "marks" : 1})

  
  
  var questionsYear2SpringShapes = [];
  questionsYear2SpringShapes.push({ "question" : "What type of shape is this?", "answer" : "Cube|Cylinder|Pyramid", "type": 1, "units" : "", "marks" : 1})
questionsYear2SpringShapes.push({ "question" : "What type of shape is this?", "answer" : "Cylinder|Cone|Cube", "type": 1, "units" : "", "marks" : 1})
questionsYear2SpringShapes.push({ "question" : "How many sides does a triangle have?", "answer" : "3", "type": 0, "units" : "sides", "marks" : 1})
questionsYear2SpringShapes.push({ "question" : "How many vertices does a square have?", "answer" : "4", "type": 0, "units" : "vertices", "marks" : 1})
questionsYear2SpringShapes.push({ "question" : "Is this a line of symmetry?", "answer" : "No|Yes", "type": 4, "units" : "", "marks" : 1})
questionsYear2SpringShapes.push({ "question" : "Is this a line of symmetry?", "answer" : "Yes|No", "type": 4, "units" : "", "marks" : 1})
questionsYear2SpringShapes.push({ "question" : "How many edges does a cuboid have? ", "answer" : "12", "type": 0, "units" : "edges", "marks" : 1})
questionsYear2SpringShapes.push({ "question" : "How many faces does a square-based pyramid have? ", "answer" : "5", "type": 0, "units" : "faces", "marks" : 1})
questionsYear2SpringShapes.push({ "question" : "What shape has 6 rectangular faces?", "answer" : "Cuboid|Cone|Pyramid", "type": 1, "units" : "", "marks" : 1})
questionsYear2SpringShapes.push({ "question" : "What is the next shape in the pattern?", "answer" : "Red triangle|Blue rectangle|Green circle", "type": 1, "units" : "", "marks" : 1})
questionsYear2SpringShapes.push({ "question" : "What is the next shape in the pattern?", "answer" : "Blue triangle|Orange square|Orange triangle", "type": 1, "units" : "", "marks" : 1})






  var questionsYear2SpringStatistics = [];
  questionsYear2SpringStatistics.push({ "question" : "Emile has drawn a bar chart showing how many of each colour of gem he has. What colour gem does Emile have most? ", "answer" : "Blue|Green|Red", "type": 1, "units" : "", "marks" : 1})
questionsYear2SpringStatistics.push({ "question" : "How many purple gems does Emile have?", "answer" : "9", "type": 0, "units" : "gems", "marks" : 1})
questionsYear2SpringStatistics.push({ "question" : "How many more red gems than pink gems does Emile have?", "answer" : "5", "type": 0, "units" : "gems", "marks" : 1})
questionsYear2SpringStatistics.push({ "question" : "How much money does Emile have?", "answer" : "80", "type": 0, "units" : "£", "marks" : 1})
questionsYear2SpringStatistics.push({ "question" : "How much more money does Aimee have than Scrambler? ", "answer" : "15", "type": 0, "units" : "£", "marks" : 1})
questionsYear2SpringStatistics.push({ "question" : "If Scrambler spends £15, how much money does he have left? ", "answer" : "30", "type": 0, "units" : "£", "marks" : 1})
questionsYear2SpringStatistics.push({ "question" : "Aimee draws a tally chart showing the colour of the gems she has. How many red gems does Aimee have? ", "answer" : "13", "type": 0, "units" : "gems", "marks" : 1})
questionsYear2SpringStatistics.push({ "question" : "How many silver and pink gems does Aimee have altogether?", "answer" : "10", "type": 0, "units" : "gems", "marks" : 1})
questionsYear2SpringStatistics.push({ "question" : "How many gems does Aimee have? ", "answer" : "49", "type": 0, "units" : "gems", "marks" : 1})


  var questionsYear3SpringFractions = [];
  questionsYear3SpringFractions.push({ "question" : "What number is missing from the number line?", "answer" : "7/10", "type": 2, "units" : "", "marks" : 1})
questionsYear3SpringFractions.push({ "question" : "Here are some red and blue gems. What fraction of the gems are <b>red</b>?", "answer" : "3/10", "type": 2, "units" : "", "marks" : 1})
questionsYear3SpringFractions.push({ "question" : "Which fraction is a unit fraction?", "answer" : "One fifth|Two sevenths|3/8", "type": 1, "units" : "", "marks" : 1})
questionsYear3SpringFractions.push({ "question" : "What number is missing from the part-whole model?", "answer" : "3/5", "type": 2, "units" : "", "marks" : 1})
questionsYear3SpringFractions.push({ "question" : "What fraction of the shape is shaded? ", "answer" : "3/8", "type": 2, "units" : "", "marks" : 1})
questionsYear3SpringFractions.push({ "question" : "What is the missing symbol? ", "answer" : "=|<|>", "type": 1, "units" : "", "marks" : 1})
questionsYear3SpringFractions.push({ "question" : "What is the missing symbol? ", "answer" : "=|<|>", "type": 1, "units" : "", "marks" : 1})
questionsYear3SpringFractions.push({ "question" : "Emile has 12 gems. He gives 1/2 to Aimee. How many gems does he give Aimee? ", "answer" : "6", "type": 0, "units" : "gems", "marks" : 1})
questionsYear3SpringFractions.push({ "question" : "Scrambler has 14 gems and gives 1/7 to Aimee. How many gems does <b>Scrambler</b> have?", "answer" : "12", "type": 0, "units" : "gems", "marks" : 1})

  var questionsYear3SpringLengthPerimeter = [];
  questionsYear3SpringLengthPerimeter.push({ "question" : "How long is this pen?", "answer" : "14", "type": 0, "units" : "cm", "marks" : 1})
questionsYear3SpringLengthPerimeter.push({ "question" : "How long is this eraser?", "answer" : "6", "type": 0, "units" : "cm", "marks" : 1})
questionsYear3SpringLengthPerimeter.push({ "question" : "What is the missing symbol? ", "answer" : "=|<|>", "type": 1, "units" : "", "marks" : 1})
questionsYear3SpringLengthPerimeter.push({ "question" : "What is the missing symbol? ", "answer" : ">|<|=", "type": 1, "units" : "", "marks" : 1})
questionsYear3SpringLengthPerimeter.push({ "question" : "What is the missing symbol? ", "answer" : "<|=|>", "type": 1, "units" : "", "marks" : 1})
questionsYear3SpringLengthPerimeter.push({ "question" : "What number is missing from the part-whole model? ", "answer" : "2", "type": 0, "units" : "mm", "marks" : 1})
questionsYear3SpringLengthPerimeter.push({ "question" : "What number is missing from the part-whole model? ", "answer" : "3", "type": 0, "units" : "cm", "marks" : 1})
questionsYear3SpringLengthPerimeter.push({ "question" : "What is the perimeter of this shape? ", "answer" : "18", "type": 0, "units" : "cm", "marks" : 1})
questionsYear3SpringLengthPerimeter.push({ "question" : "A square has a perimeter of 12cm. How long is each side? ", "answer" : "3", "type": 0, "units" : "cm", "marks" : 1})

  
  var questionsYear3SpringMoney = [];
  questionsYear3SpringMoney.push({ "question" : "How much money is shown?", "answer" : "£8 and 31p|£8 and 26p|£5 and 26p", "type": 1, "units" : "", "marks" : 1})
questionsYear3SpringMoney.push({ "question" : "How much money is shown?", "answer" : "£8 and 25p|£8 and 15p|£4 and 15p", "type": 1, "units" : "", "marks" : 1})
questionsYear3SpringMoney.push({ "question" : "Emile is given some coins. If he spends £2.40, how much money does he have left? ", "answer" : "£5 and 4p|£5 and 44p|£5", "type": 1, "units" : "", "marks" : 1})
questionsYear3SpringMoney.push({ "question" : "How many 10p coins make £1?", "answer" : "10", "type": 0, "units" : "coins", "marks" : 1})
questionsYear3SpringMoney.push({ "question" : "£4 and 50p = ? ", "answer" : "450", "type": 0, "units" : "pence", "marks" : 1})
questionsYear3SpringMoney.push({ "question" : "£7 = ? ", "answer" : "700", "type": 0, "units" : "pence", "marks" : 1})
questionsYear3SpringMoney.push({ "question" : "How much is a red gem and a green gem? ", "answer" : "£7 and 30p|£5 and 40p|£8", "type": 1, "units" : "", "marks" : 1})
questionsYear3SpringMoney.push({ "question" : "How much is a red gem and an orange gem? ", "answer" : "£8|£7 and 30p|£5 and 40p", "type": 1, "units" : "", "marks" : 1})
questionsYear3SpringMoney.push({ "question" : "Aimee has a £10 note. She buys a blue and a green gem. How much change does she receive?", "answer" : "£3 and 50p|£2|£4 and 60p", "type": 1, "units" : "", "marks" : 1})
questionsYear3SpringMoney.push({ "question" : "Emile has a £20 note. He buys: a green, a blue and a red gem. How much money does he have left? ", "answer" : "£10 and 30p|£9 and 30p|£9 and 70p", "type": 1, "units" : "", "marks" : 1})

  


  var questionsYear3SpringMultiplicationDivision = [];
  questionsYear3SpringMultiplicationDivision.push({ "question" : "Emile has 28 gems. He puts an equal number of gems into 7 boxes. How many gems are in each box?", "answer" : "4", "type": 0, "units" : "gems", "marks" : 1})
questionsYear3SpringMultiplicationDivision.push({ "question" : "Scrambler has 5 crates each with 26 gems in each crate. How many gems does Scrambler have? ", "answer" : "130", "type": 0, "units" : "gems", "marks" : 1})
questionsYear3SpringMultiplicationDivision.push({ "question" : "Aimee has 7 crates each with 18 gems. How many gems does Aimee have? ", "answer" : "126", "type": 0, "units" : "gems", "marks" : 1})
questionsYear3SpringMultiplicationDivision.push({ "question" : "Using the array, which statement is <b>false</b>?", "answer" : "8 ÷ 6 = 48|48 ÷ 6 = 8|8 x 6 = 48", "type": 1, "units" : "", "marks" : 1})
questionsYear3SpringMultiplicationDivision.push({ "question" : "What is 43 x 4?", "answer" : "172", "type": 0, "units" : "", "marks" : 1})
questionsYear3SpringMultiplicationDivision.push({ "question" : "Calculate 84 ÷ 4", "answer" : "21", "type": 0, "units" : "", "marks" : 1})
questionsYear3SpringMultiplicationDivision.push({ "question" : "Aimee is organising gems. She splits the gems up by colour. She has 5 of each colour and there are 6 colours. How many gems does she have? ", "answer" : "30", "type": 0, "units" : "gems", "marks" : 1})
questionsYear3SpringMultiplicationDivision.push({ "question" : "Emile also has some gems. He separates them into piles of 4. He makes 6 piles and has 2 gems left over. How many gems does Emile have?  ", "answer" : "26", "type": 0, "units" : "gems", "marks" : 1})
questionsYear3SpringMultiplicationDivision.push({ "question" : "Scrambler has some red and blue gems. He has 4 times as many blue gems as red gems and has 7 red gems. How many gems does Scrambler have altogether? ", "answer" : "35", "type": 0, "units" : "gems", "marks" : 1})


  


  var questionsYear3SpringStatistics = [];
  questionsYear3SpringStatistics.push({ "question" : "This is a bar chart showing how many gems Emile, Aimee and Scrambler have. Who has the most gems? ", "answer" : "Emile|Aimee|Scrambler", "type": 1, "units" : "", "marks" : 1})
questionsYear3SpringStatistics.push({ "question" : "This is a bar chart showing how many gems Emile, Aimee and Scrambler have. How many gems does Scrambler have?", "answer" : "12", "type": 0, "units" : "gems", "marks" : 1})
questionsYear3SpringStatistics.push({ "question" : "This is a bar chart showing how many gems Emile, Aimee and Scrambler have. How many gems do Aimee and Emile have together?", "answer" : "31", "type": 0, "units" : "gems", "marks" : 1})
questionsYear3SpringStatistics.push({ "question" : "This is a bar chart showing how many gems Emile, Aimee and Scrambler have. How many gems more gems does Aimee have  than Scrambler?", "answer" : "3", "type": 0, "units" : "gems", "marks" : 1})
questionsYear3SpringStatistics.push({ "question" : "This is a table showing how far Aimee travelled everyday last week.  How far did she travel on Thursday?", "answer" : "25", "type": 0, "units" : "km", "marks" : 1})
questionsYear3SpringStatistics.push({ "question" : "This is a table showing how far Aimee travelled everyday last week.  How much further did she travel on Wednesday than Saturday?", "answer" : "16", "type": 0, "units" : "km", "marks" : 1})
questionsYear3SpringStatistics.push({ "question" : "This is a table showing how far Aimee travelled everyday last week.  How far did she travel last week?", "answer" : "139", "type": 0, "units" : "km", "marks" : 1})
questionsYear3SpringStatistics.push({ "question" : "This pictogram shows how many gems Emile has found in the last year. What colour gem did Emile find the most of in the last year? ", "answer" : "Green|Red|Blue", "type": 1, "units" : "", "marks" : 1})
questionsYear3SpringStatistics.push({ "question" : "This pictogram shows how many gems Emile has found in the last year. How many green gems has Emile found?", "answer" : "50", "type": 0, "units" : "gems", "marks" : 1})
questionsYear3SpringStatistics.push({ "question" : "This pictogram shows how many gems Emile has found in the last year. How many more blue gems than purple gems has Emile found? ", "answer" : "15", "type": 0, "units" : "gems", "marks" : 1})
questionsYear3SpringStatistics.push({ "question" : "This pictogram shows how many gems Emile has found in the last year. How many gems has Emile found this year? ", "answer" : "145", "type": 0, "units" : "gems", "marks" : 1})

  

  
  var questionsYear4SpringDecimals = [];
  questionsYear4SpringDecimals.push({ "question" : "Emile makes a number with counters. How many tenths are there?", "answer" : "4", "type": 0, "units" : "", "marks" : 1})
questionsYear4SpringDecimals.push({ "question" : "Emile makes a number with counters. How many hundredths are there?", "answer" : "5", "type": 0, "units" : "", "marks" : 1})
questionsYear4SpringDecimals.push({ "question" : "Emile makes a number with counters. What number has he made? ", "answer" : "0.45", "type": 0, "units" : "", "marks" : 1})
questionsYear4SpringDecimals.push({ "question" : "What number is shown on the place value grid? ", "answer" : "0.3", "type": 0, "units" : "", "marks" : 1})
questionsYear4SpringDecimals.push({ "question" : "What number is shown on the place value grid? ", "answer" : "0.54", "type": 0, "units" : "", "marks" : 1})
questionsYear4SpringDecimals.push({ "question" : "What number does A represent on the number line? ", "answer" : "9/10", "type": 2, "units" : "", "marks" : 1})
questionsYear4SpringDecimals.push({ "question" : "Each hundred grid represents one whole. What fraction is shaded? ", "answer" : "37/100", "type": 2, "units" : "", "marks" : 1})
questionsYear4SpringDecimals.push({ "question" : "What is 7 divided by 10?", "answer" : "0.7", "type": 0, "units" : "", "marks" : 1})
questionsYear4SpringDecimals.push({ "question" : "What is 5 ÷ 100?", "answer" : "0.05", "type": 0, "units" : "", "marks" : 1})
questionsYear4SpringDecimals.push({ "question" : "What is 72 ÷ 100?", "answer" : "0.72", "type": 0, "units" : "", "marks" : 1})




  var questionsYear4SpringDivision = [];
  questionsYear4SpringDivision.push({ "question" : "Emile has 24 gems. He separates them equally in to 3 jars. How many gems go  in each jar? ", "answer" : "8", "type": 0, "units" : "gems", "marks" : 1})
questionsYear4SpringDivision.push({ "question" : "Emile has 24 gems as shown in the array. What statement represents the array? ", "answer" : "8 x 3 = 24|8 ÷ 24 = 3|7 x 3 = 21", "type": 1, "units" : "", "marks" : 1})
questionsYear4SpringDivision.push({ "question" : "Scrambler buys the crates of gems shown. How many gems has Scrambler bought? ", "answer" : "555", "type": 0, "units" : "gems", "marks" : 1})
questionsYear4SpringDivision.push({ "question" : "8 gems weigh 96 grams. What does 1 gem weigh? ", "answer" : "12", "type": 0, "units" : "grams", "marks" : 1})
questionsYear4SpringDivision.push({ "question" : "8 gems weigh 96 grams. What do 5 gems weigh? ", "answer" : "60", "type": 0, "units" : "grams", "marks" : 1})
questionsYear4SpringDivision.push({ "question" : "Work out 34 ÷ 3 = ?", "answer" : "11 remainder 1|11|12", "type": 1, "units" : "", "marks" : 1})
questionsYear4SpringDivision.push({ "question" : "Work out 765 ÷ 5 = ?", "answer" : "153", "type": 0, "units" : "", "marks" : 1})
questionsYear4SpringDivision.push({ "question" : "Work out 148 ÷ 4 = ?", "answer" : "37", "type": 0, "units" : "", "marks" : 1})
questionsYear4SpringDivision.push({ "question" : "396 gems are packed equally into 3 crates. How many gems are in each crate?", "answer" : "132", "type": 0, "units" : "gems", "marks" : 1})
questionsYear4SpringDivision.push({ "question" : "What number is missing? ", "answer" : "637", "type": 0, "units" : "", "marks" : 1})





  var questionsYear4SpringFractions = [];
  questionsYear4SpringFractions.push({ "question" : "What fraction is labelled A on the number line? ", "answer" : "5/6", "type": 2, "units" : "", "marks" : 1})
questionsYear4SpringFractions.push({ "question" : "What fraction of the shape is shaded? ", "answer" : "3/8", "type": 2, "units" : "", "marks" : 1})
questionsYear4SpringFractions.push({ "question" : "What is three quarters written using numbers? ", "answer" : "3/4", "type": 2, "units" : "", "marks" : 1})
questionsYear4SpringFractions.push({ "question" : "Complete the equivalent fractions.", "answer" : "4", "type": 0, "units" : "", "marks" : 1})
questionsYear4SpringFractions.push({ "question" : "Complete the equivalent fractions.", "answer" : "9", "type": 0, "units" : "", "marks" : 1})
questionsYear4SpringFractions.push({ "question" : "Complete the part whole model.", "answer" : "1/3", "type": 2, "units" : "", "marks" : 1})
questionsYear4SpringFractions.push({ "question" : "Complete the part whole model.", "answer" : "5/7", "type": 2, "units" : "", "marks" : 1})
questionsYear4SpringFractions.push({ "question" : "Complete the part whole model.", "answer" : "8/7", "type": 2, "units" : "", "marks" : 1})
questionsYear4SpringFractions.push({ "question" : "Calculate: ", "answer" : "2/11", "type": 2, "units" : "", "marks" : 1})
questionsYear4SpringFractions.push({ "question" : "Calculate: ", "answer" : "3", "type": 0, "units" : "", "marks" : 1})
questionsYear4SpringFractions.push({ "question" : "What is the missing number? ", "answer" : "88", "type": 0, "units" : "", "marks" : 1})

  


  var questionsYear4SpringMultiplication = [];
  questionsYear4SpringMultiplication.push({ "question" : "Emile has arranged his gems in an array. Which multiplication statement represents the array? ", "answer" : "4 x 8 = 32|3 x 8 = 24|3 x 7 = 21", "type": 1, "units" : "", "marks" : 1})
questionsYear4SpringMultiplication.push({ "question" : "Aimee is using place value counters to work out 24 x 5. What is 24 x 5 = ", "answer" : "120", "type": 0, "units" : "", "marks" : 1})
questionsYear4SpringMultiplication.push({ "question" : "29 x 7 = ", "answer" : "203", "type": 0, "units" : "", "marks" : 1})
questionsYear4SpringMultiplication.push({ "question" : "134 x 8 = ", "answer" : "1072", "type": 0, "units" : "", "marks" : 1})
questionsYear4SpringMultiplication.push({ "question" : "4 x 265 x 2 = ", "answer" : "2120", "type": 0, "units" : "", "marks" : 1})
questionsYear4SpringMultiplication.push({ "question" : "There are 121 gems on 4 different planets. How many gems are there on the planets altogether?", "answer" : "484", "type": 0, "units" : "gems", "marks" : 1})
questionsYear4SpringMultiplication.push({ "question" : "Scrambler has five £20 notes. How much money does he have? ", "answer" : "100", "type": 0, "units" : "£", "marks" : 1})
questionsYear4SpringMultiplication.push({ "question" : "Emile has £1,200. He buys 4 silver gems. Each silver gem costs £190. How much money does Emile have left? ", "answer" : "440", "type": 0, "units" : "£", "marks" : 1})
questionsYear4SpringMultiplication.push({ "question" : "What is the missing number?", "answer" : "1", "type": 0, "units" : "", "marks" : 1})



  

  var questionsYear5SpringDecimalsPercentages = [];
  questionsYear5SpringDecimalsPercentages.push({ "question" : "Here is a hundred square that represents a whole. What fraction of the grid is shaded? ", "answer" : "37/100", "type": 2, "units" : "", "marks" : 1})
questionsYear5SpringDecimalsPercentages.push({ "question" : "Here is a hundred square that represents a whole. What percentage of the grid is shaded? ", "answer" : "37", "type": 0, "units" : "%", "marks" : 1})
questionsYear5SpringDecimalsPercentages.push({ "question" : "Emile has made a number. What number has he made as a decimal? ", "answer" : "0.27", "type": 0, "units" : "", "marks" : 1})
questionsYear5SpringDecimalsPercentages.push({ "question" : "Emile has made a number. What number has he made as a fraction? ", "answer" : "25/100|1/25|2/5", "type": 1, "units" : "", "marks" : 1})
questionsYear5SpringDecimalsPercentages.push({ "question" : "What symbol is missing? ", "answer" : ">|<|=", "type": 1, "units" : "", "marks" : 1})
questionsYear5SpringDecimalsPercentages.push({ "question" : "What symbol is missing? ", "answer" : "=|<|>", "type": 1, "units" : "", "marks" : 1})
questionsYear5SpringDecimalsPercentages.push({ "question" : "Complete the statement: ", "answer" : "2", "type": 0, "units" : "", "marks" : 1})
questionsYear5SpringDecimalsPercentages.push({ "question" : "Complete the statement: ", "answer" : "4", "type": 0, "units" : "", "marks" : 1})
questionsYear5SpringDecimalsPercentages.push({ "question" : "On the planet there are 1,000 gems with 673 of the gems being  blue gems. What fraction of the gems on the planet are blue gems? ", "answer" : "673/1000", "type": 2, "units" : "", "marks" : 1})
questionsYear5SpringDecimalsPercentages.push({ "question" : "What is 853/1000 as a decimal?", "answer" : "0.853", "type": 0, "units" : "", "marks" : 1})
questionsYear5SpringDecimalsPercentages.push({ "question" : "Emile has 100 gems. 33 gems are green and 18 are blue gems. What fraction of Emile's gems are blue or green? ", "answer" : "51/100", "type": 2, "units" : "", "marks" : 1})
questionsYear5SpringDecimalsPercentages.push({ "question" : "Emile has 100 gems. 17 gems are red gems. What percentage of Emile's gems are red? ", "answer" : "17", "type": 0, "units" : "%", "marks" : 1})

  var questionsYear5SpringFractionsA = [];
  questionsYear5SpringFractionsA.push({ "question" : "What fraction of the shape is shaded? ", "answer" : "4/15", "type": 2, "units" : "", "marks" : 1})
questionsYear5SpringFractionsA.push({ "question" : "Complete the equivalent fraction: ", "answer" : "3", "type": 0, "units" : "", "marks" : 1})
questionsYear5SpringFractionsA.push({ "question" : "Complete the equivalent fraction: ", "answer" : "7", "type": 0, "units" : "", "marks" : 1})
questionsYear5SpringFractionsA.push({ "question" : "Complete the equivalent fraction: ", "answer" : "26", "type": 0, "units" : "", "marks" : 1})
questionsYear5SpringFractionsA.push({ "question" : "Convert 5/4 to a mixed number.", "answer" : "1&1/4", "type": 3, "units" : "", "marks" : 1})
questionsYear5SpringFractionsA.push({ "question" : "Convert 2&2/3 to a improper fraction. ", "answer" : "8/3", "type": 2, "units" : "", "marks" : 1})
questionsYear5SpringFractionsA.push({ "question" : "Complete:", "answer" : "17", "type": 0, "units" : "", "marks" : 1})
questionsYear5SpringFractionsA.push({ "question" : "Complete:", "answer" : "2&2/5", "type": 3, "units" : "", "marks" : 1})
questionsYear5SpringFractionsA.push({ "question" : "What is the missing symbol: ", "answer" : ">|<|=", "type": 1, "units" : "", "marks" : 1})
questionsYear5SpringFractionsA.push({ "question" : "What is the missing symbol: ", "answer" : "<|>|=", "type": 1, "units" : "", "marks" : 1})
questionsYear5SpringFractionsA.push({ "question" : "17 ÷ 3 = [?]", "answer" : "5&2/3", "type": 3, "units" : "", "marks" : 1})
questionsYear5SpringFractionsA.push({ "question" : "Emile and Aimee have the same number of gems. 2/3 of Emile's gems are blue. 1/2 of Aimee's gems are blue. Who has the most gems? ", "answer" : "Emile|Aimee", "type": 4, "units" : "", "marks" : 1})


  var questionsYear5SpringFractionsB = [];
  questionsYear5SpringFractionsB.push({ "question" : "2/5 + 1/5 + 1/5 = ?", "answer" : "4/5", "type": 2, "units" : "", "marks" : 1})
questionsYear5SpringFractionsB.push({ "question" : "3/5 - 1/5 = ?", "answer" : "2/5", "type": 2, "units" : "", "marks" : 1})
questionsYear5SpringFractionsB.push({ "question" : "1 - 1/5 = ?", "answer" : "4/5", "type": 2, "units" : "", "marks" : 1})
questionsYear5SpringFractionsB.push({ "question" : "Using the bars, what is 1/5 + 1/10 = ?", "answer" : "3/10", "type": 2, "units" : "", "marks" : 1})
questionsYear5SpringFractionsB.push({ "question" : "Using the bars, what is 2/3 + 1/6 = ?", "answer" : "5/6", "type": 2, "units" : "", "marks" : 1})
questionsYear5SpringFractionsB.push({ "question" : "2/5 - 3/10 = ? ", "answer" : "1/10", "type": 2, "units" : "", "marks" : 1})
questionsYear5SpringFractionsB.push({ "question" : "1/3 + 1/6 - 1/12 = ?", "answer" : "5/12", "type": 2, "units" : "", "marks" : 1})
questionsYear5SpringFractionsB.push({ "question" : "What is the missing number? ", "answer" : "5", "type": 0, "units" : "", "marks" : 1})
questionsYear5SpringFractionsB.push({ "question" : "What number does A represent on the number line? ", "answer" : "4&2/5", "type": 3, "units" : "", "marks" : 1})
questionsYear5SpringFractionsB.push({ "question" : "Emile has 1&2/5 litres of rocket fuel in his fuel tank. The fuel tank can hold 5&7/10 litres of rocket fuel. How much more rocket fuel can Emile's fuel tank hold? ", "answer" : "4&3/10", "type": 3, "units" : "", "marks" : 1})
questionsYear5SpringFractionsB.push({ "question" : "1/4 of Emile's gems are blue. 1/3 of Emile's gems are green. What fraction of Emile's gems are blue or green? ", "answer" : "7/12", "type": 2, "units" : "", "marks" : 1})



  var questionsYear5SpringMultiplication = [];
  questionsYear5SpringMultiplication.push({ "question" : "Calculate", "answer" : "248", "type": 0, "units" : "", "marks" : 1})
questionsYear5SpringMultiplication.push({ "question" : "Calculate", "answer" : "205", "type": 0, "units" : "", "marks" : 1})
questionsYear5SpringMultiplication.push({ "question" : "Calculate", "answer" : "5424", "type": 0, "units" : "", "marks" : 1})
questionsYear5SpringMultiplication.push({ "question" : "What number is missing from the multiplication grid? ", "answer" : "12", "type": 0, "units" : "", "marks" : 1})
questionsYear5SpringMultiplication.push({ "question" : "Chairs in the hall are arranged in 32 rows. In each and every row there are 48 chairs. How many chairs are there altogether?", "answer" : "1536", "type": 0, "units" : "", "marks" : 1})
questionsYear5SpringMultiplication.push({ "question" : "What number is missing from the calculation? ", "answer" : "2", "type": 0, "units" : "", "marks" : 1})
questionsYear5SpringMultiplication.push({ "question" : "Emile thinks of a number. When he mulitplies his number by 8, he gets 136. With what number does Emile start? ", "answer" : "17", "type": 0, "units" : "", "marks" : 1})
questionsYear5SpringMultiplication.push({ "question" : "Calculate", "answer" : "7784", "type": 0, "units" : "", "marks" : 1})
questionsYear5SpringMultiplication.push({ "question" : "Blue gems cost £65. Eight blue gems and 5 red gems cost £880. How much does a red gem cost? ", "answer" : "72", "type": 0, "units" : "£", "marks" : 1})
questionsYear5SpringMultiplication.push({ "question" : "Calculate", "answer" : "5040", "type": 0, "units" : "", "marks" : 1})



var questionsYear6SpringAlgebra = [];
questionsYear6SpringAlgebra.push({ "question" : "If red gems = 5 and blue gems = 6, find the total. ", "answer" : "27", "type": 0, "units" : "", "marks" : 1})
questionsYear6SpringAlgebra.push({ "question" : "Below is a function machine. Complete the sentence. When the input is 3, the output is ?.", "answer" : "7", "type": 0, "units" : "", "marks" : 1})
questionsYear6SpringAlgebra.push({ "question" : "Below is a function machine. Complete the sentence. When the output is 9, the input is ?.", "answer" : "5", "type": 0, "units" : "", "marks" : 1})
questionsYear6SpringAlgebra.push({ "question" : "Solve the equation: ", "answer" : "4", "type": 0, "units" : "x =", "marks" : 1})
questionsYear6SpringAlgebra.push({ "question" : "Solve the equation: ", "answer" : "8", "type": 0, "units" : "y = ", "marks" : 1})
questionsYear6SpringAlgebra.push({ "question" : "Solve the equation: ", "answer" : "3", "type": 0, "units" : "z = ", "marks" : 1})
questionsYear6SpringAlgebra.push({ "question" : "a and b are positive integers. a + b = 6.  If a is 4, what is b?", "answer" : "2", "type": 0, "units" : "b =", "marks" : 1})
questionsYear6SpringAlgebra.push({ "question" : "a and b are positive integers. a + b = 6.  If b is 1, what is a?", "answer" : "5", "type": 0, "units" : "a =", "marks" : 1})
questionsYear6SpringAlgebra.push({ "question" : "p and q are positive integers. 2p + q = 8.  If p is 2, what is q?", "answer" : "4", "type": 0, "units" : "q =", "marks" : 1})
questionsYear6SpringAlgebra.push({ "question" : "p and q are positive integers. 2p + q = 8.  If q is 2, what is p?", "answer" : "3", "type": 0, "units" : "p = ", "marks" : 1})
questionsYear6SpringAlgebra.push({ "question" : "p and q are positive integers. 12p + 5 = 113.  What is p?", "answer" : "9", "type": 0, "units" : "p = ", "marks" : 1})
questionsYear6SpringAlgebra.push({ "question" : "Emile is working out how much fuel he needs to power his rocket. He uses the formula shown below, where D is the distance travelled and L is the number of launches. Work out the amount of fuel Emile needs to travel a distance of 6km with 1 launch. ", "answer" : "45", "type": 0, "units" : "litres", "marks" : 1})
questionsYear6SpringAlgebra.push({ "question" : "Aimee sets off on a trip with 1 launch. She uses 80 litres of fuel. How far did she travel?", "answer" : "13", "type": 0, "units" : "km", "marks" : 1})


var questionsYear6SpringConvertingUnits = [];
questionsYear6SpringConvertingUnits.push({ "question" : "What is the most appropriate unit of measure for the weight of a chair?", "answer" : "kg|g|m", "type": 1, "units" : "", "marks" : 1})
questionsYear6SpringConvertingUnits.push({ "question" : "What is the most appropriate unit of measure for the height of a building?", "answer" : "m|cm|km", "type": 1, "units" : "", "marks" : 1})
questionsYear6SpringConvertingUnits.push({ "question" : "What is the most appropriate estimate for the weight of a book?", "answer" : "500g|8kg|2g", "type": 1, "units" : "", "marks" : 1})
questionsYear6SpringConvertingUnits.push({ "question" : "What is the weight of the gem?", "answer" : "450", "type": 0, "units" : "g", "marks" : 1})
questionsYear6SpringConvertingUnits.push({ "question" : "What is the weight of the gem in kilograms?", "answer" : "0.45", "type": 0, "units" : "kg", "marks" : 1})
questionsYear6SpringConvertingUnits.push({ "question" : "What symbol is missing?", "answer" : "=|<|>", "type": 1, "units" : "", "marks" : 1})
questionsYear6SpringConvertingUnits.push({ "question" : "What symbol is missing?", "answer" : ">|<|=", "type": 1, "units" : "", "marks" : 1})
questionsYear6SpringConvertingUnits.push({ "question" : "What symbol is missing?", "answer" : "<|>|=", "type": 1, "units" : "", "marks" : 1})
questionsYear6SpringConvertingUnits.push({ "question" : "What symbol is missing?", "answer" : "=|<|>", "type": 1, "units" : "", "marks" : 1})
questionsYear6SpringConvertingUnits.push({ "question" : "What symbol is missing?", "answer" : ">|<|=", "type": 1, "units" : "", "marks" : 1})
questionsYear6SpringConvertingUnits.push({ "question" : "5 miles ≈ 8 kilometres. Emile flies 20 miles. How far as he travelled in kilometres?", "answer" : "32", "type": 0, "units" : "kilometres", "marks" : 1})


var questionsYear6SpringDecimals = [];
questionsYear6SpringDecimals.push({ "question" : "What is 1.53 + one tenth?", "answer" : "1.6", "type": 0, "units" : "", "marks" : 1})
questionsYear6SpringDecimals.push({ "question" : "What is 1.672 + three hundredths?", "answer" : "1.702", "type": 0, "units" : "", "marks" : 1})
questionsYear6SpringDecimals.push({ "question" : "Emile has made a number with some counters. What number has Emile made? ", "answer" : "5.46", "type": 0, "units" : "", "marks" : 1})
questionsYear6SpringDecimals.push({ "question" : "Calculate:", "answer" : "0.68", "type": 0, "units" : "", "marks" : 1})
questionsYear6SpringDecimals.push({ "question" : "Calculate:", "answer" : "2.6", "type": 0, "units" : "", "marks" : 1})
questionsYear6SpringDecimals.push({ "question" : "Calculate:", "answer" : "389", "type": 0, "units" : "", "marks" : 1})
questionsYear6SpringDecimals.push({ "question" : "Calculate:", "answer" : "4730", "type": 0, "units" : "", "marks" : 1})
questionsYear6SpringDecimals.push({ "question" : "Emile has made a number on a place value grid and then times this number by three. What number has he made? ", "answer" : "96.3", "type": 0, "units" : "", "marks" : 1})
questionsYear6SpringDecimals.push({ "question" : "What is 9.63 divided by 3?", "answer" : "3.21", "type": 0, "units" : "", "marks" : 1})
questionsYear6SpringDecimals.push({ "question" : "What is the fraction 1/4 as a decimal?", "answer" : "0.25", "type": 0, "units" : "", "marks" : 1})
questionsYear6SpringDecimals.push({ "question" : "What is the decimal 0.3 expressed as a fraction?", "answer" : "3/10", "type": 2, "units" : "", "marks" : 1})
questionsYear6SpringDecimals.push({ "question" : "Emile shares fuel with Scrambler and Aimee. Each of them receives 4.75 litres. How much fuel was there in total?", "answer" : "14.25", "type": 0, "units" : "litres", "marks" : 1})
questionsYear6SpringDecimals.push({ "question" : "Emile can buy packs of 3 gems for £15.36 or a pack of 4 gems for £20.54. What is the smallest amount Emile could pay per gem?", "answer" : "5.12", "type": 0, "units" : "£", "marks" : 1})


var questionsYear6SpringPercentages = [];
questionsYear6SpringPercentages.push({ "question" : "What percentage of the hundred grid is shaded? ", "answer" : "40", "type": 0, "units" : "%", "marks" : 1})
questionsYear6SpringPercentages.push({ "question" : "What percentage of the hundred grid is shaded? ", "answer" : "87", "type": 0, "units" : "%", "marks" : 1})
questionsYear6SpringPercentages.push({ "question" : "What is 50% of 44 litres?", "answer" : "22", "type": 0, "units" : "litres", "marks" : 1})
questionsYear6SpringPercentages.push({ "question" : "What is 25% of 24 litres?", "answer" : "6", "type": 0, "units" : "litres", "marks" : 1})
questionsYear6SpringPercentages.push({ "question" : "Emile has 20 litres of fuel, but needs 5% more to complete his journey. How much fuel should he buy?", "answer" : "1", "type": 0, "units" : "litres", "marks" : 1})
questionsYear6SpringPercentages.push({ "question" : "What is 10% of 60? ", "answer" : "6", "type": 0, "units" : "", "marks" : 1})
questionsYear6SpringPercentages.push({ "question" : "What is 5% of 60? ", "answer" : "3", "type": 0, "units" : "", "marks" : 1})
questionsYear6SpringPercentages.push({ "question" : "What is 40% of 60? ", "answer" : "24", "type": 0, "units" : "", "marks" : 1})
questionsYear6SpringPercentages.push({ "question" : "What is 90% of 60? ", "answer" : "54", "type": 0, "units" : "", "marks" : 1})
questionsYear6SpringPercentages.push({ "question" : "50% of a number is 22. What is the number?", "answer" : "44", "type": 0, "units" : "", "marks" : 1})
questionsYear6SpringPercentages.push({ "question" : "10% of a number is 3.2. What is the number?", "answer" : "32", "type": 0, "units" : "", "marks" : 1})
questionsYear6SpringPercentages.push({ "question" : "What is 1/2 expressed as a percentage?", "answer" : "50", "type": 0, "units" : "%", "marks" : 1})
questionsYear6SpringPercentages.push({ "question" : "What is 9% expressed as a fraction?", "answer" : "9/100", "type": 2, "units" : "", "marks" : 1})
questionsYear6SpringPercentages.push({ "question" : "What is 0.3 expressed as a percentage?", "answer" : "30", "type": 0, "units" : "%", "marks" : 1})
questionsYear6SpringPercentages.push({ "question" : "What is 17% expressed as a decimal?", "answer" : "0.17", "type": 0, "units" : "", "marks" : 1})
questionsYear6SpringPercentages.push({ "question" : "Emile has categorised his gems into colours and has drawn a percentage bar chart. What percentage of his gems are green?", "answer" : "20", "type": 0, "units" : "%", "marks" : 1})
questionsYear6SpringPercentages.push({ "question" : "Emile has categorised his gems into colours and has drawn a percentage bar chart. What percentage of his gems are orange?", "answer" : "10", "type": 0, "units" : "%", "marks" : 1})
questionsYear6SpringPercentages.push({ "question" : "Emile has categorised his gems into colours and has drawn a percentage bar chart. What percentage of his gems are blue?", "answer" : "30", "type": 0, "units" : "%", "marks" : 1})
questionsYear6SpringPercentages.push({ "question" : "Emile goes on a long trip in his rocket with 150 litres of fuel. Setting off, he uses 15% of his fuel on launch and 40% during the journey. Landing uses 5% of his fuel. How many litres of fuel does he have left? ", "answer" : "60", "type": 0, "units" : "litres", "marks" : 1})



var questionsYear6SpringPerimetersAreasVolumes = [];
questionsYear6SpringPerimetersAreasVolumes.push({ "question" : "What is the perimeter of the shape shown? ", "answer" : "14", "type": 0, "units" : "cm", "marks" : 1})
questionsYear6SpringPerimetersAreasVolumes.push({ "question" : "What is the area of the shape shown? ", "answer" : "9", "type": 0, "units" : "cm²", "marks" : 1})
questionsYear6SpringPerimetersAreasVolumes.push({ "question" : "What is the area of the triangle? ", "answer" : "20", "type": 0, "units" : "cm²", "marks" : 1})
questionsYear6SpringPerimetersAreasVolumes.push({ "question" : "What is the area of the triangle? ", "answer" : "24", "type": 0, "units" : "cm²", "marks" : 1})
questionsYear6SpringPerimetersAreasVolumes.push({ "question" : "What is the volume of the cube? ", "answer" : "64", "type": 0, "units" : "cm³", "marks" : 1})
questionsYear6SpringPerimetersAreasVolumes.push({ "question" : "What is the volume of the cuboid? ", "answer" : "120", "type": 0, "units" : "cm³", "marks" : 1})
questionsYear6SpringPerimetersAreasVolumes.push({ "question" : "Below is a rectilinear shape. What is the size of side A? ", "answer" : "10", "type": 0, "units" : "cm", "marks" : 1})
questionsYear6SpringPerimetersAreasVolumes.push({ "question" : "Below is a rectilinear shape. What is the size of side B? ", "answer" : "5", "type": 0, "units" : "cm", "marks" : 1})
questionsYear6SpringPerimetersAreasVolumes.push({ "question" : "Below is a rectilinear shape. What is the area of the shape? ", "answer" : "175", "type": 0, "units" : "cm²", "marks" : 1})



var questionsYear6SpringRatios = [];
questionsYear6SpringRatios.push({ "question" : "For every rocket, there are how many gems?", "answer" : "2", "type": 0, "units" : "gems", "marks" : 1})
questionsYear6SpringRatios.push({ "question" : "For every square, how many circles are there?", "answer" : "5", "type": 0, "units" : "circles", "marks" : 1})
questionsYear6SpringRatios.push({ "question" : "For every 1p coin, Emile has a £1 coin. Is this true or false? ", "answer" : "False|True", "type": 4, "units" : "", "marks" : 1})
questionsYear6SpringRatios.push({ "question" : "The ratio of 10p coins to 20p coins is? ", "answer" : "8:5|10:20|4:10", "type": 1, "units" : "", "marks" : 1})
questionsYear6SpringRatios.push({ "question" : "The ratio of 20p coins to 10p coins is?", "answer" : "5:8|20:10|10:4", "type": 1, "units" : "", "marks" : 1})
questionsYear6SpringRatios.push({ "question" : "Which ratio is equivalent to 8:6?", "answer" : "4:3|3:4|2:3", "type": 1, "units" : "", "marks" : 1})
questionsYear6SpringRatios.push({ "question" : "For every 2 red gems, there are 3 blue gems. If there are 30 gems, how many are blue?", "answer" : "18", "type": 0, "units" : "blue gems", "marks" : 1})
questionsYear6SpringRatios.push({ "question" : "The ratio of silver gems to blue gems is 1:20. If there are 100 blue gems, how many silver gems are there?", "answer" : "5", "type": 0, "units" : "silver gems", "marks" : 1})
questionsYear6SpringRatios.push({ "question" : "The shape is divided into equal sections. What fraction is shaded?", "answer" : "3/10", "type": 2, "units" : "", "marks" : 1})
questionsYear6SpringRatios.push({ "question" : "The shape is divided into equal sections. What percentage is shaded?", "answer" : "30", "type": 0, "units" : "%", "marks" : 1})
questionsYear6SpringRatios.push({ "question" : "The shape is divided into equal sections. What is the ratio of shaded to unshaded sections?", "answer" : "3:7|4:7|3:4", "type": 1, "units" : "", "marks" : 1})
questionsYear6SpringRatios.push({ "question" : "Square B is an enlargement of square A. What is the enlargement scale factor?", "answer" : "1.5|1|2", "type": 1, "units" : "", "marks" : 1})



var timer = -1;

//above is questions section
  
  console.log(props);

  if (status == false){
    currQuestion = [];
    console.log("STATUS IS FALSE");
    questionNum = 0;
    useranswers = [];
    shuffledAnswers = [];
    var query = props.assessment_type[0] + props.assessment_type[3];
    console.log("QUERY IS: " + query)
    //check what questions it is, checking year first will check terms later like summer etc
    if (query == "2springdivision"){
      setQuestions(questionsYear2SpringDivision);
    } else if (query == "2springfractions"){
      setQuestions(questionsYear2SpringFractions);
    }
    else if (query == "2springshapes"){
      setQuestions(questionsYear2SpringShapes);
    }
    else if (query == "2springstatistics"){
      setQuestions(questionsYear2SpringStatistics);
    }
    else if (query == "3springfractions"){
      setQuestions(questionsYear3SpringFractions);
    }
    else if (query == "3springlength&perimeter"){
      setQuestions(questionsYear3SpringLengthPerimeter);
    }
    else if (query == "3springmoney"){
      setQuestions(questionsYear3SpringMoney);
    }
    else if (query == "3springmultiplication&division"){
      setQuestions(questionsYear3SpringMultiplicationDivision);
    }
    else if (query == "3springstatistics"){
      setQuestions(questionsYear3SpringStatistics);
    }
    else if (query == "4springdecimals"){
      setQuestions(questionsYear4SpringDecimals);
    }
    else if (query == "4springdivision"){
      setQuestions(questionsYear4SpringDivision);
    }
    else if (query == "4springfractions"){
      setQuestions(questionsYear4SpringFractions);
    }
    else if (query == "4springmultiplication"){
      setQuestions(questionsYear4SpringMultiplication);
    }
    else if (query == "5springdecimals&percentages"){
      setQuestions(questionsYear5SpringDecimalsPercentages);
    }
    else if (query == "5springfractionsa"){
      setQuestions(questionsYear5SpringFractionsA);
    }
    else if (query == "5springfractionsb"){
      setQuestions(questionsYear5SpringFractionsB);
    }
    else if (query == "5springmultiplication"){
      setQuestions(questionsYear5SpringMultiplication);
    }
    else if (query == "6springalgebra"){
      setQuestions(questionsYear6SpringAlgebra);
    }
    else if (query == "6springconvertingunits"){
      setQuestions(questionsYear6SpringConvertingUnits);
    }
    else if (query == "6springdecimals"){
      setQuestions(questionsYear6SpringDecimals);
    }
    else if (query == "6springpercentages"){
      setQuestions(questionsYear6SpringPercentages);
    }
    else if (query == "6springperimetersareas&volumes"){
      setQuestions(questionsYear6SpringPerimetersAreasVolumes);
    }
    else if (query == "6pringratios"){
      setQuestions(questionsYear6SpringRatios);
    }
    setStatus(true);
  }
  console.log(questions);

  if (useranswers.length == 0 && questions.length > 0){
    for (let i = 0; i < questions.length; i++) {
      useranswers.push("");
      shuffledAnswers.push("");
      //DO SHUFFLE QUESTIONS
      if (questions[i].type == 1){
        let choices = questions[i].answer.split("|");
        choices = shuffleArray(choices);
        shuffledAnswers[i] = choices;
      }
    }
    console.log("initial Answers array:")
    console.log(useranswers);
  }


  var questionMax = -1;
  if(props.minimum > 0)
  {
      questionMax = props.minimum;
  }

  function reduceTimer() {
    console.log(waitTime);
  setWaitTime(waitTime - 1);
  }

  console.log("question number: " + questionNum);

  /*TODO: 
  only submit at the end
  may need to scrap a lot of the core code and do it from the ground up
  create a new calculator class just for assessments
  the background image method needs to set it equal to currentquestion number

  */

  //Sets the question to a new one, currently no check for being the same question
  function newQuestion() {
    //questionNum++;
    currQuestion = questions[questionNum];
    console.log("Current question");
    console.log(currQuestion);
    console.log("Answers so far:");
    console.log(useranswers);
    setCurrentQuestion(currQuestion);
    setRefresh(!refresh);
    //CheckImage();
  }


  //Called on click
  async function checkResult(value, callback) {
    var isCorrect = true;
    if (value) {
      console.log(value.value + " " + currQuestion.correct);
      //correct answer
      if (currQuestion.correct === value.value) {
        setCorrectQuestions([...correctQuestions, currQuestion]);
        let multiplier = combo > 0 ? combo + 1 : 1;
        multiplier = multiplier > 5 ? 5 : multiplier;
        setScore(score + multiplier * 10);

        if (combo < 99) {
          setCombo(combo + 1);
        }
        if (combo > maxCombo) {
          setMaxCombo(combo);
        }

        newQuestion();
      }
      //incorrect answer
      else {
        isCorrect = false;
        setIncorrectQuestions([...incorrectQuestions, currQuestion]);
        if (combo === 0 && score >= 10) {
          setScore(score - 10);
        } else {
          setCombo(0);
        }

        let result = {
          question: currQuestion.question,
          correct: currQuestion.correct,
          incorrect: value.value
        };

        setFeedback([...feedback, result]);
        setColouredFeedback(true);
        setWaitTime(2);
      }
      //Generates a new question
      //newQuestion();

    }
  }

  useEffect(() => {
    if (waitTime > 0) {
        var waitttimerID = setInterval(() => reduceTimer(), 1000);
        return () => {
            clearInterval(waitttimerID);
        };
    } else {

        setColouredFeedback(false);
        newQuestion();
    }
  },[waitTime]);

  //Set the first question, called until questions are defined
  useEffect(() => {
    if (questions !== undefined) {
      console.log(questions);
      var sample = questions[questionNum];
      currQuestion = sample;
      setCurrentQuestion(currQuestion);
      //CheckImage();
    }
  }, [questions]);

  //No clue
  useEffect(() => {
    if (status !== undefined && status == true) {
      setLoading(false);
    }
  }, [status]);


  function QuestionImage() {
    //IF QUESTION NUMBER GREATER THAN NUMBER OF QUESTIONS DISPLAY BLANK BACKGROUND
    if (questionNum >= questions.length){
      return blankbg;
    }
    let requireString = "BlockSpring/";
    requireString+= props.assessment_type[0] + props.assessment_type[3] + (questionNum+1) + ".png";
    //requireString += "/question"+(questionNum+1)+".png";
    return (require("../../assets/maths_assessments/assets/"+requireString))
}

async function setAnswer(value)
  {
    console.log("SET VALUE");
    console.log(value);
    useranswers[questionNum] = value;
    console.log(useranswers);
  }

  function NavigationButtons(){
    if (questionNum != 0 && questionNum != questions.length){
      return (
        <div>
        <NavigationButtonBack
        onClick={() => previousQuestion()}>
          <NavigationTextBack>
            Back
          </NavigationTextBack>
        </NavigationButtonBack>
        <NavigationButton
        onClick={() => nextQuestion()}>
          <NavigationText>
            Next
          </NavigationText>
        </NavigationButton>
        </div>
      );
    }else if (questionNum < questions.length){
      return (
      <div>
      <NavigationButton
      onClick={() => nextQuestion()}>
        <NavigationText>
          Next
        </NavigationText>
        
      </NavigationButton>
      </div>
      );
    }
    else{
      return (
        <div>
         <NavigationButtonBack
        onClick={() => previousQuestion()}>
          <NavigationTextBack>
            Back
          </NavigationTextBack>
        </NavigationButtonBack>

        <Button onClick={() => GameOver()} style={{fontSize: "3em", height: "100px", width: "300px", position: "relative", right: "-45%", textAlign: "center", lineHeight: "3.2"}}>
          Submit
        </Button>
        </div>
        );
    }
  }

  function GameOver(){
    setGameOver(true);//go to endscreen
  }

  function CompareIfCorrect(youranswer, question){
    if (question.type != 1){
      if (question.answer == youranswer){
        return true;
      }else{
        return false;
      }
    }else{
      let correct = question.answer.split("|")[0];
      if (youranswer == correct){
        return true;
      }else{
        return false;
      }
    }
  }

  //I moved this to be called from the practicegameassessment script so it is done on timeout and ending game
  async function SubmitAssessment(){
     let correct = 0;      
    let questionsAnswered = [];
    for (let i = 0; i < questions.length; i++) {
        if (CompareIfCorrect(useranswers[i], questions[i])){
          let data = {
            question: questions[i].question,
            correct: true,
            answer: useranswers[i]
        };
        correct++;
        questionsAnswered.push(data);
        }else{
          let data = {
            question: questions[i].question,
            correct: false,
            answer: useranswers[i]
        };
        questionsAnswered.push(data);
        }
      console.log(JSON.stringify(questionsAnswered));
    }

    let topicstats = [];
    let temptih = {
      topic_key : "mathsassessmentsub",
      game_key : "basic_mathments",
      num_asked : questionsAnswered.length,
      num_correct : correct,
      average_ans_time : "0.0"
    }
    topicstats.push(temptih);

    axios({
        url: `${process.env.REACT_APP_API}/submissions`,
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Authorization": `Bearer ${authState.access_token}`
        },
        data: {
            "homework_id": props.homework.id,
            "topicstats": topicstats,
            "custom": null,
            "platform": "Assessment|" + "WEB" + "|" + process.env.REACT_APP_VERSION_NO,
            "game_id": props.homework.galaxy_id,
            "questionsAnswered": JSON.stringify(questionsAnswered)
        }
      }).then((response) => {
        setGameOver(true);//go to endscreen
      })
  }

  function SubmitTimeout(){
    SubmitAssessment();
  }

  
  async function nextQuestion(value)
  {
    questionNum++;
    //will haver to do something for when questionum == to the question list count to display the final submission page
    newQuestion();
    //setClear(true);
  }

  function ResetClear(){
    setClear(false);
  }

  async function previousQuestion(value)
  {
    questionNum--;
    //will haver to do something for when questionum == to the question list count to display the final submission page
    newQuestion();
  }

  //this returns a table that ticks what questions are done
   function GetEndTable(){
    var html = "";
    html+= "<div>"
    //create a table where it equals amount of questions
    html+= '<table style="margin-top: 20%; width:100%; border-collapse: collapse;">'
    html+= '<tr>'

    for (let i = 0; i < questions.length; i++) {
      console.log(i);
      html+= '<td style="height: 100px, text-align:center; font-size: 4em;">'
      html+= 'Q'+(i+1);
      html+= '</td>';
    }
    html+='</tr><tr>';
    
    useranswers.forEach(element => {
      if (element == ""){
        html+= '<td style="height: 100px; border: 1px solid #9999;"> </td>'
      }else{
        html+= '<td style="height: 100px; background: #FFA500; border: 1px solid #9999;"> </td>'
      }
    });
    html+= "</tr>";
    html+="</table>";
    html+= "</div>";

    return html;
  }

  //if the user presses a multichoice button
  function PressMulti(value) {
    useranswers[questionNum] = value;
    setRefresh(!refresh);
  }

  function MultichoiceButtons(){
    //var choices = currQuestion.answer.split("|");
    //choices = shuffleArray(choices);
    let choices = shuffledAnswers[questionNum];

    return (
    <div>
       {choices.map(answer => {
        if(useranswers[questionNum] == "" || answer != useranswers[questionNum]){
          return (
            <MButton
            {...console.log(answer)}
            value={<div dangerouslySetInnerHTML={answer} />}
            style={{ flex: 1, margin: "20px" }}
            onClick={() => PressMulti(answer)}
          >
              <div style={{ height: "80%", width: "100%" }}>
              <Textfit mode="multi" max="99" style={{ textShadow: "2px 2px 4px #000000", position: "relative", top: "24%", height: "90%" }}>
                  {answer}
                </Textfit>
              </div>
          </MButton>
         )}
        return (
          <MButtonSelected
          {...console.log("SELECTED")}
          value={<div dangerouslySetInnerHTML={answer} />}
          style={{ flex: 1, margin: "20px" }}
          onClick={() => PressMulti(answer)}
        >
            <div style={{ height: "80%", width: "100%" }}>
              <Textfit mode="multi" max="99" style={{ textShadow: "2px 2px 4px #000000", position: "relative", top: "24%", height: "90%" }}>
                {answer}
              </Textfit>
            </div>
        </MButtonSelected>
        )
      })}
    </div>
    )
  }

  function ShowMarks(){
    //IF QUESTION NUMBER GREATER THAN NUMBER OF QUESTIONS DISPLAY BLANK BACKGROUND
    if (questionNum >= questions.length){
      return "";
    }else{
      return marks1;
    }
  }

  //I don't know how to comment html/CSS
  return (
    <>
      <PracticeGame
        parent={props}
        gameOver={gameOver}
        SubmitMethod={() => SubmitTimeout()}
        correct={correctQuestions}
        incorrect={incorrectQuestions}
        score={score}
        defaultTimer={timer}
        questionNum={questionNum}
        questionNumMax ={questions.length}
        questionLimit={questionMax}
        onBack={() => props.onBack()}
        loading={loading}
        feedback={feedback}
        questionFontSize="0.7em"
        restart={() => {
          setCombo(0);
          setScore(0);
          setCorrectQuestions([]);
          setIncorrectQuestions([]);
        }}
      >
        <div id="scalinghere">
        <div style={{ backgroundImage: `url(${ShowMarks()}), url(${QuestionImage()})`, position: "relative", top: "-10%", height: "1400px", backgroundSize: "cover" }} >
            <Body>
              
              <div style={{ width: "80%" }}>
                {currQuestion != undefined ? (


                  <Container update={refresh}>

                    <div style={{ display: "flex", flexDirection: "row", alignSelf: "flex-end" }}>
                        <div style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between"
                        }}>
                          {currQuestion.type == 0 &&
                            <AsCalculator
                            onChange={setAnswer}
                            fakeprop={true}
                            resetclear = {ResetClear}
                            currentQuestion={currQuestion}
                            currentAnswer={useranswers[questionNum]}
                            //ref={this.calculator}
                            />
                          }
                          {currQuestion.type == 1 &&
                            <MultiChoiceContainer>
                            {MultichoiceButtons()}
                            </MultiChoiceContainer>
                            }
                {currQuestion.type == 2 &&
                 <AsCalculatorFraction
                 onChange={setAnswer}
                 fakeprop={true}
                 resetclear = {ResetClear}
                 currentQuestion={currQuestion}
                 currentAnswer={useranswers[questionNum]}
                 //ref={this.calculator}
                 />

                }
                 {currQuestion.type == 3 &&
                 <AsCalculatorFractionMixed
                 onChange={setAnswer}
                 fakeprop={true}
                 resetclear = {ResetClear}
                 currentQuestion={currQuestion}
                 currentAnswer={useranswers[questionNum]}
                 //ref={this.calculator}
                 />

                }
                {currQuestion.type == 4 &&
                            <MultiChoiceContainer>
                            {MultichoiceButtons()}
                            </MultiChoiceContainer>
                }    
                        </div>
                    </div>
                    <NavigationContainer>
                    {NavigationButtons()}
                    </NavigationContainer>

                  </Container>

                ) : <div>
                <div dangerouslySetInnerHTML={{ __html: GetEndTable() }}>
                </div><NavigationContainer>{NavigationButtons()}</NavigationContainer></div> }
              </div>
            </Body>
            </div>
        </div>
      </PracticeGame>
    </>
  );
}

const MultiChoiceContainer = styled.div`
  position: relative;
  top: 50%;
  right: 20%;
`

const NavigationContainer = styled.div`
  position: fixed;
  top: 70%;
  right: 50%;
`

const Body = styled.div`
        width: 100%;
        height: 100%;
  background-image: url("");
        background-size: cover;
        background-position: 0px -1px;
        display: flex;
        justify-content: center;
        padding-top: 100px;
      `;

const Result = styled.div`
        width: 100%;
        height: 100%;
        font-size: 5em;
        text-align: center;
        border: solid 2px #683d8c;
      `;

const Combo = styled.div`
        background: #4391bb;
        width: 120px;
        height: 120px;
        border-radius: 75px;
        border: solid #204b7b 4px;
        display: flex;
        flex-direction: column;
        text-align: center;
        color: #fff;
        justify-content: center;
        font-weight: 600;
        margin-left: 50px;
      `;

const Marks = styled.div`
      font-size: 4em;
      position: relative;
      right: 33%;
      top: 73%;
    `;

const Container = styled.div`
      width:100%%;
      height:95%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom:100px;
      `;

const Question = styled.div`
      background: #FFF;
      user-select: none;
      width: 90%;
      height: 120px;
      line-height: 90px;
      font-size: 4em;
      margin: 15px 25px;
      text-align: center;
      font-weight: 600;
      border: none;
      border-radius: 10px;
    `;

const Button = styled.div`
    text-align: center;
    width: 20%;
    height: 150px;
    margin: 5px;
    color: #fff;
    user-select: none;
    background: rgb(234, 146, 19);
    background: linear-gradient(
      0deg,
      rgba(234, 146, 19, 1) 0%,
      rgba(255, 186, 32, 1) 100%
    );
    border: 2px solid #e88f12;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
  `;

  const MButton = styled.div`
    text-align: center;
    width: 350px;
    height: 150px;
    margin: 5px;
    color: #fff;

    background: linear-gradient(
      0deg,
      rgba(200, 200, 200, 1) 0%,
      rgba(225, 225, 225, 1) 100%
    );
    border: 2px solid #fff;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
    user-select: none; /* supported by Chrome and Opera */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
  `;

  const MButtonSelected = styled.div`
  text-align: center;
  width: 350px;
  height: 150px;
  margin: 5px;
  color: #fff;
  background: linear-gradient(
    0deg,
    rgba(200, 200, 120, 1) 0%,
    rgba(225, 225, 100, 1) 100%
  );
  border: 2px solid #fff;
  box-sizing: border-box;
  border-radius: 0.25em;
  cursor: pointer;
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
`;

const NavigationButton = styled.div`
text-align: center;
width: 118px;
height: 144px;
margin: 5px;
position: absolute;
right: -1000px;
top: 150px
background-image: url(${next});
color: #000;
user-select: none;
box-sizing: border-box;
border-radius: 0.25em;
cursor: pointer;
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  margin-bottom: 0;
}
`;

const NavigationButtonBack = styled.div`
text-align: center;
width: 118px;
height: 144px;
margin: 5px;
position: absolute;
top: 150px;
right: 1000px
background-image: url(${back});
color: #000;
box-sizing: border-box;
border-radius: 0.25em;
cursor: pointer;
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  margin-bottom: 0;
}
`;

  const NavigationText = styled.div`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 40%;
  transform: translate(-50%, -50%);
  font-size: 25px;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
}
  `;

  const NavigationTextBack = styled.div`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 60%;
  transform: translate(-50%, -50%);
  font-size: 25px;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  `;

const ButtonImage = styled.img`
max-width: 80%;
max-height: 80%;
padding-top: 15px;
`